import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import ReactGA from 'react-ga4';

// Importations CSS importantes
import 'packages/common/locales/i18n';
import 'simplebar-react/dist/simplebar.min.css';
import 'react-quill/dist/quill.snow.css';
import 'react-lazy-load-image-component/src/effects/blur.css';

// Providers et composants importants
import {LocalizationProvider} from 'packages/common/locales';
import ThemeProvider from 'packages/common/theme';
import {SettingsProvider} from 'packages/common/components/settings';
import {MotionLazy} from 'packages/common/components/animate/motion-lazy';
import {SnackbarProvider} from 'packages/common/components/snackbar';
import Router from './routes';
import {LoadingScreen} from 'packages/common/components/loading-screen';
import {Suspense} from 'react';
import ProgressBar from 'packages/common/components/progress-bar';

export default function App() {
  const location = useLocation();

  // GA INIT
  useEffect(() => {
    try {
      ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
    } catch (error) {
      console.error('Failed to initialize GA4:', error);
    }
  }, []);

  // GA PAGEVIEW
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location.pathname, location.search]);

  return (
    <HelmetProvider>
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <ProgressBar />
                <Suspense fallback={<LoadingScreen />}>
                  <Router />
                </Suspense>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </HelmetProvider>
  );
}
